// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BlogBreadcrumb_wrap__47zde","breadcrumbWrap":"BlogBreadcrumb_breadcrumbWrap__Bwr_q","breadcrumb":"BlogBreadcrumb_breadcrumb__F2uWS","link":"BlogBreadcrumb_link__2hHWE"};